import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import TillRepositoryForm from './forms/TillRepositoryForm';
import TillRepositoryList from './lists/TillRepositoryList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class TillRepositoryEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Pénztárak"}
                    footer={[
                        <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <TillRepositoryList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Kassza"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>,
                        <Button key="1" disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                                color="danger"
                                className="pull-left"
                                onClick={this.props.deleteForm}>
                            Törlés
                        </Button>
                    ]}
                >
                    <TillRepositoryForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "TillRepository", WrappedComponent: TillRepositoryEditor});
